import axios from "@/utils/axios";
import { useQuery, useMutation } from "@tanstack/react-query";
import { type ApiFaqlResponseType } from "@/types/entities/faq";
import type { DataManagerResult } from "@/pages/portal/faqs/components/data-manager";

// OBTENER FAQS
export const useGetFaqs = () => {
  return useQuery<ApiFaqlResponseType>({
    queryKey: ["faq"],
    queryFn: async () => {
      const { data } = await axios.get("/mock/admin/v1/faqs");
      return data;
    },
  });
};

export type SCategory = {
  id: string;
  name: string;
  created_at: string;
  updated_at: string;
  order: number;
};

// CATEGORÍAS DE FAQ
export const useListFaqCategories = (canRead?: boolean) => {
  return useQuery({
    queryKey: ["faq-categories"],
    queryFn: async (): Promise<{
      data: SCategory[];
    }> => {
      const { data } = await axios.get("admin/v1/faq-categories");
      return data;
    },
    enabled: canRead,
  });
};

type CreateFaqCategoryPayload = {
  name: string;
  order?: number;
};

// CREAR CATEGORÍA
export const useCreateFaqCategory = () => {
  return useMutation({
    mutationFn: async (payload: CreateFaqCategoryPayload) => {
      const { data } = await axios.post("admin/v1/faq-categories", payload);
      return data;
    },
  });
};

type UpdateFaqCategoryPayload = {
  id: string;
  name: string;
  order?: number;
};

// ACTUALIZAR CATEGORÍA
export const useUpdateFaqCategory = () => {
  return useMutation({
    mutationFn: async ({ id, name, order }: UpdateFaqCategoryPayload) => {
      const { data } = await axios.put(`admin/v1/faq-categories/${id}`, {
        name,
        order,
      });
      return data;
    },
  });
};

// ELIMINAR CATEGORÍA
export const useDeleteFaqCategory = () => {
  return useMutation({
    mutationFn: async (id: string) => {
      const { data } = await axios.delete(`admin/v1/faq-categories/${id}`);
      return data;
    },
  });
};

// LISTAR FAQS (incluyendo borradores)
export const useListFaqs = (canRead: boolean) => {
  return useQuery<ApiFaqlResponseType>({
    queryKey: ["faq", { with_drafts: true }],
    queryFn: async () => {
      const { data } = await axios.get("admin/v1/faqs", {
        params: { with_drafts: 1 },
      });
      return data;
    },
    enabled: canRead,
  });
};

// REFRESCAR FAQS EN MASA
export const useRefreshFaqs = () => {
  return useMutation({
    mutationFn: async (payload: DataManagerResult) => {
      const { data } = await axios.post(
        "admin/v1/faqs/massive-refresh",
        payload,
      );
      return data;
    },
  });
};
